package features.shifts.ui.modals

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object EditShiftModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "edit-shift-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Edit Shift Template" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("space-y-4 mb-6") {
                    // Hidden input for shift ID
                    input(type = InputType.hidden) {
                        id = "edit-shift-id-input"
                    }
                    
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Shift Code" }
                        input(classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                            id = "edit-shift-code-input"
                            placeholder = "e.g. S1, MOR, NGT"
                        }
                    }
                    div("grid grid-cols-2 gap-4") {
                        div {
                            label("block text-sm text-slate-400 mb-1") { +"Start Time" }
                            div("flex gap-2") {
                                select("flex-1 bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                    id = "edit-shift-start-hour"
                                    (0..23).forEach { hour ->
                                        option { value = hour.toString().padStart(2, '0'); +hour.toString().padStart(2, '0') }
                                    }
                                }
                                span("text-white text-xl flex items-center") { +":" }
                                select("flex-1 bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                    id = "edit-shift-start-minute"
                                    listOf("00", "15", "30", "45").forEach { minute ->
                                        option { value = minute; +minute }
                                    }
                                }
                            }
                        }
                        div {
                            label("block text-sm text-slate-400 mb-1") { +"End Time" }
                            div("flex gap-2") {
                                select("flex-1 bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                    id = "edit-shift-end-hour"
                                    (0..23).forEach { hour ->
                                        option { value = hour.toString().padStart(2, '0'); +hour.toString().padStart(2, '0') }
                                    }
                                }
                                span("text-white text-xl flex items-center") { +":" }
                                select("flex-1 bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                    id = "edit-shift-end-minute"
                                    listOf("00", "15", "30", "45").forEach { minute ->
                                        option { value = minute; +minute }
                                    }
                                }
                            }
                        }
                    }
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Color" }
                        div("flex gap-2 items-center") {
                            id = "edit-shift-color-picker"
                            listOf("#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4").forEach { color ->
                                button(classes = "w-10 h-10 rounded-lg border-2 transition") {
                                    id = "edit-color-btn-$color"
                                    type = ButtonType.button
                                    style = "background-color: $color; border-color: transparent"
                                    onClickFunction = { 
                                        js("selectEditShiftColor")(color)
                                        // Update all color buttons
                                        listOf("#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4").forEach { c ->
                                            val btn = document.getElementById("edit-color-btn-$c") as? org.w3c.dom.HTMLElement
                                            btn?.style?.borderColor = if (c == color) "white" else "transparent"
                                        }
                                    }
                                }
                            }
                            // Custom color picker
                            div("relative") {
                                input(type = InputType.color, classes = "w-10 h-10 rounded-lg border-2 border-dark-600 cursor-pointer") {
                                    id = "edit-shift-color-picker-input"
                                    value = "#10b981"
                                    title = "Custom color"
                                    attributes["onchange"] = "selectEditShiftColorFromPicker(this.value)"
                                }
                            }
                        }
                    }
                }
                
                div("flex justify-end gap-3") {
                    button(classes = "px-4 py-2 rounded-xl text-slate-300 hover:bg-dark-700 transition") {
                        type = ButtonType.button
                        onClickFunction = { ModalManager.close() }
                        +"Cancel"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-brand-cyan text-white hover:bg-brand-green transition") {
                        type = ButtonType.button
                        onClickFunction = { js("updateShift")() }
                        +"Save Changes"
                    }
                }
            }
        }
    }
}
